import icon1 from '../../../Assets/Icons/feature1.svg';
import icon2 from '../../../Assets/Icons/feature2.svg';
import icon3 from '../../../Assets/Icons/feature3.svg';
import icon4 from '../../../Assets/Icons/feature4.svg';
import icon5 from '../../../Assets/Icons/feature5.svg';
import icon6 from '../../../Assets/Icons/feature6.svg';



export const featuresList = [
    {
        icon:icon1,
        title:"Take photos of sketches",
        desc:"Go from a napkin sketch to a fully functional prototype in minutes",
        bgColor:"#F1EBFF",
        bgColor2:"#622AF2"
    },
    {
        icon:icon2,
        title:"Build prototypes",
        desc:"Create beautifully presented desktop and mobile prototypes",
        bgColor:"#ec63233b",
        bgColor2:"#EC6423"
    },
    {
        icon:icon3,
        title:"Offline Prototypes",
        desc:"Pre-download all your prototypes and view them with no internet connection",
        bgColor:"#ffbf002d",
        bgColor2:"#FFC000"
    },
    {
        icon:icon4,
        title:"Sync from Sketch",
        desc:"Seamlessly import prototypes and sync artboards from Sketch into HostDesign",
        bgColor:"#02eb0223",
        bgColor2:"#02EB02"
    },
    {
        icon:icon5,
        title:"Apple TV",
        desc:"HostDesign lets you play and preview all your prototypes on the Apple TV",
        bgColor:"#ff4f5b2f",
        bgColor2:"#FF4F5A"
    },
    {
        icon:icon6,
        title:"Apple Watch",
        desc:"View your prototypes directly on the Apple Watch",
        bgColor:"#17a8ec25",
        bgColor2:"#17A7EC"
    }
]